import React, { useContext } from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { SubscriptionPurchaseFTUEContext } from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';
import StageBackground from '../../DeviationBackground/StageBackground';
import DeviationFullView from '../../DeviationViews/Full';
import Duperswiper from '../_partials/Duperswiper';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { useMobileStage } from '../hooks/useMobileStage';
import s from './MobileArtStage.scss';
const MobileArtStage = ({ className , deviation , isZoomed , onEnterZoomMode , onExitZoomMode  })=>{
    const { contentSize , containerSize  } = useMobileStage(deviation);
    // polls and statuses put all their content into the art stage and thus need to be unlimited in height
    const noStageHeight = [
        DeviationTypes.POLL,
        DeviationTypes.STATUS
    ].includes(getDeviationType(deviation));
    const isSubscriptionPurchaseFTUEBeingShown = !!useContext(SubscriptionPurchaseFTUEContext);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(className, s['root']),
        "data-hook": BiDataHook.DEVIATION_ART_STAGE
    }, /*#__PURE__*/ React.createElement(Duperswiper, {
        key: deviation.deviationId,
        deviation: deviation,
        height: noStageHeight ? 'auto' : get(containerSize, 'height'),
        width: get(containerSize, 'width')
    }, (dev)=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(StageBackground, {
            deviation: dev,
            height: get(containerSize, 'height'),
            width: get(containerSize, 'width')
        }), /*#__PURE__*/ React.createElement(DeviationFullView, {
            deviation: dev,
            isZoomed: isZoomed,
            onEnterZoomMode: onEnterZoomMode,
            onExitZoomMode: onExitZoomMode,
            height: noStageHeight ? undefined : get(contentSize, 'height'),
            width: get(contentSize, 'width')
        }), isSubscriptionPurchaseFTUEBeingShown && /*#__PURE__*/ React.createElement(SubscriptionPurchaseFTUE, null))));
};
MobileArtStage.displayName = 'MobileArtStage';
export default MobileArtStage;
